import { AsProp, NullableClassName } from '@squareup/dex-types-shared-ui';
import {
  Paragraph20,
  Paragraph30,
  TextVariants,
} from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import styles from './http-method-string.module.css';

type HttpMethods = 'GET' | 'PUT' | 'POST' | 'DELETE' | 'EVENT' | 'DEPRECATED';

export interface HttpMethodStringProps {
  httpMethod: HttpMethods;
  textVariant?: TextVariants['variant'] | undefined;
}

const HttpMethodString: FunctionComponent<
  HttpMethodStringProps & AsProp & NullableClassName
> = ({ httpMethod, textVariant, as, className }) => {
  const ParagraphVariant = textVariant === '20' ? Paragraph20 : Paragraph30;
  return (
    <ParagraphVariant
      weight="medium"
      as={as}
      className={clsx(styles[httpMethod], className)}
    >
      {httpMethod}
    </ParagraphVariant>
  );
};

export { type HttpMethods, HttpMethodString };
